import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { AverageWalkingSpeedCardData } from './averageWalkingSpeedCardData';
import { AverageWalkingSpeedPanel } from './AverageWalkingSpeedPanel';

interface AverageWalkingSpeedCardProps {
  data?: AverageWalkingSpeedCardData;
  onClick: () => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageWalkingSpeedCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageWalkingSpeedCard: React.FC<AverageWalkingSpeedCardProps> = ({
  data,
  onClick,
}: AverageWalkingSpeedCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageWalkingSpeed.title')}
      iconName="AverageWalkingSpeedParam"
      popoverContent={t('averageWalkingSpeed.popover')}
      onClick={onClick}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageWalkingSpeed.description')}
      </CardDetailTypography>
      <AverageWalkingSpeedCardMedia>
        {data && data.value ? (
          <PanelDisplayBox>
            <AverageWalkingSpeedPanel
              minValue={0}
              maxValue={2.5}
              range={[0, 1.25, 2.5]}
              value={data ? Number(data.value) : 0}
              unit={data ? data.unit : 'm/s'}
            />
          </PanelDisplayBox>
        ) : null}
      </AverageWalkingSpeedCardMedia>
    </ParameterCard>
  );
};

export default AverageWalkingSpeedCard;
